import { type ReactNode } from 'react';
import { FoundersHero } from './founders-hero';
import { FoundersJump } from './founders-jump';
import { FoundersGrid } from './founders-grid';
import { FOUNDERS_TOTAL } from '../founders-config';

function scrollToSlot(n: number): void {
  const el = document.getElementById(`founder-${n}`);
  if (!el) return;
  el.scrollIntoView({ behavior: 'smooth', block: 'center' });
}

export function FoundersPage(): ReactNode {
  return (
    <div className="space-y-lg">
      <FoundersHero />
      <FoundersJump total={FOUNDERS_TOTAL} onJump={scrollToSlot} />
      <FoundersGrid />
    </div>
  );
}
